const services = [
  {
    icon: 'ri-tools-line',
    title: 'Plumbing Services',
    description: 'Expert plumbing repairs, installations, and maintenance for all your home needs.'
  },
  {
    icon: 'ri-temp-cold-line',
    title: 'HVAC Installation & Repair',
    description: 'Keep your home comfortable year-round with professional heating and cooling services.'
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Electrical Work',
    description: 'Licensed electricians for safe and reliable electrical installations and repairs.'
  },
  {
    icon: 'ri-plant-line',
    title: 'Landscaping & Lawn Care',
    description: 'Transform your outdoor space with professional landscaping and maintenance services.'
  },
  {
    icon: 'ri-home-4-line',
    title: 'Roof Repair',
    description: 'Protect your home with quality roofing repairs and replacement services.'
  },
  {
    icon: 'ri-hammer-line',
    title: 'Home Remodeling',
    description: 'Complete renovation services to transform your living spaces into your dream home.'
  }
];

export default function Services() {
  return (
    <section id="services" className="py-20 md:py-32 px-4 sm:px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-20">
          <p className="text-[#1e40af] text-xs font-bold uppercase tracking-widest mb-4">OUR SERVICES</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#2C2C2C]">Complete Home Solutions</h2>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 sm:p-10 shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 cursor-pointer"
            >
              <div className="w-16 h-16 bg-[#F0F7FF] rounded-full flex items-center justify-center mx-auto mb-5">
                <i className={`${service.icon} text-3xl text-[#1e40af]`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-[#2C2C2C] text-center mb-3">{service.title}</h3>
              <p className="text-sm sm:text-base text-[#6B6B6B] text-center leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
